@if (entityType$ | async; as entityType) {
  <form action="" [formGroup]="cloneForm">
    <div fxLayout="row" fxLayoutGap="30px">
      <mat-form-field appearance="outline" fxFlex="50" (click)="openSourceEventsDialog()">
        <mat-label data-testid="sourceEvent">Source Event</mat-label>
        <input matInput readonly formControlName="sourceEvent" placeholder="Choose Source Event" />
        @if (cloneForm.controls['sourceEvent'].hasError('required')) {
          <mat-error>
            Source event is required
          </mat-error>
        }
        @if (cloneForm.controls['sourceEvent'].hasError('invalid')) {
          <mat-error>
            {{cloneForm.controls['sourceEvent'].getError('invalid')}}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex="50" (click)="openDestinationEventsDialog()">
        <mat-label data-testid="destinationEvent">Destination Event</mat-label>
        <input matInput readonly formControlName="destinationEvent" placeholder="Choose Destination Event" />
        @if (cloneForm.controls['destinationEvent'].hasError('required')) {
          <mat-error>
            Destination Event is required
          </mat-error>
        }
        @if (cloneForm.controls['destinationEvent'].hasError('invalid')) {
          <mat-error>
            {{cloneForm.controls['destinationEvent'].getError('invalid')}}
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="30px">
      <mat-form-field appearance="outline" fxFlex="50">
        <mat-label data-testid="Versions">Versions</mat-label>
        <mat-select multiple formControlName="versions">
          @if (versionList.length) {
            <mat-option [value]="'allVersions'" (click)="toggleSelectAllVersions($event)"> All Versions </mat-option>
          }
          @for (version of versionList; track version) {
            <mat-option [value]="version.Id">
              {{version?.VersionName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div fxLayout="column" fxFlex="50" class="checkbox-group">
        @if (destinationEventId === sourceEventId) {
          <mat-checkbox formControlName="IncludeVersions">Include Versions Assigned</mat-checkbox>
        }
        <mat-checkbox formControlName="KeepCurrentStatus">Keep Current Offer Status</mat-checkbox>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="30px">
      <mat-form-field appearance="outline" fxFlex="50">
        <mat-label data-testid="Pages">Pages</mat-label>
        <mat-select multiple multiple (selectionChange)="onFilterChange($event)">
          @for (page of printPagesList; track page) {
            <mat-option [value]="page.Id">
              {{page?.PageFrom}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="start start" fxLayoutGap.lt-md="4px" class="actions-bar">
      <h2>Select {{entityType === CloneType.OFFER ? 'Offers': entityType === CloneType.PROMO ? 'Promos' : entityType ===
      CloneType.OFFERGROUP ? 'Offer Groups' : 'Events'}} to Clone</h2>
      <mat-form-field appearance="outline" class="mat-form-field-no-padding">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Search</mat-label>
        <input matInput type="text" (input)="onSearch($event)" placeholder="Search" #searchInput />
        @if (searchInput.value) {
          <button type="button" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
      <span class="menu-spacer"></span>
    </div>
    <div class="seleted-offers">
      <span>
        ({{ selectedRecords.length }}
        {{entityType === CloneType.OFFER ? 'Offer(s)': entityType === CloneType.PROMO ? 'Promo(s)' : entityType ===
        CloneType.OFFERGROUP ? 'Offer Group(s)' : 'Event(s)'}}
        Selected)
      </span>
    </div>
  </form>
  @if (viewMode === 'TABLE') {
    <app-clone-offers-list-table #offerPromoCloneTable [destinationEventId]="destinationEventId"></app-clone-offers-list-table>
  }
  <mat-card-actions fxLayout="row" fxLayoutAlign="end">
    <div fxLayout="row" fxLayoutAlign="end start" >
      <button mat-stroked-button type="button" (click)="closeDialog()" style="margin-right: 10px;">
        Cancel
      </button>
      <button mat-raised-button type="button" color="accent" [disabled]="cloneForm.invalid || !selectedRecords.length || isCloning"
        (click)="cloneEvent()">
        Clone {{entityType === CloneType.OFFER ? 'Offers': entityType === CloneType.PROMO ? 'Promos' : entityType ===
        CloneType.OFFERGROUP ? 'Offer Groups' : 'Events'}}
      </button>
    </div>
  </mat-card-actions>
} @else {
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
}

